module.exports = __webpack_public_path__ + "static/media/FS_Purple.e5429d80.png";